var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19",
    width: 18,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #f99d20;stroke-linecap:round;stroke-linejoin:round;stroke-width: 2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Residential"
  }, /*#__PURE__*/React.createElement("g", {
    id: "07.Doody.Marketing.Free-Quotes.Service-Details.01.2.1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "shp0",
    d: "M4.2 14.8C1.26 11.87 1.26 7.13 4.2 4.2C7.13 1.26 11.87 1.26 14.8 4.2C17.74 7.13 17.74 11.87 14.8 14.8C11.87 17.74 7.13 17.74 4.2 14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "shp0",
    d: "M12.68 9.5L6.32 9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "shp0",
    d: "M9.5 6.32L9.5 12.68"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.e6d057830261af19841a3e8a1356e37b.svg";
export { ForwardRef as ReactComponent };